<template>
  <div class="header jobPosingSearch row flexHeader" :class="{ 'font-size-18 jobPosingSearchPC': $store.state.innerWidth > 768, showExtraHeight: showExtra }">
    <div class="warp-mask"></div>
    <div class="job-containers col-sm-10 col-md-8 padLeft-0 padRight-0" style="width: 1280px !important">
      <h1 class="job-contant Bold" :class="{ 'font-size-60': $store.state.innerWidth > 768 }">
        {{ $t("message.Find a Job Opportunity") }}
      </h1>
      <div class="search-criteria-w">
        <div class="row search-criteria">
          <div class="col-sm-8 col-lg-9">
            <div class="row">
              <div class="col-sm-6 pad-10">
                <div class="input-group">
                  <b class="i-left">
                    <i class="icon-search gray" aria-hidden="true"></i>
                  </b>
                  <input
                    maxlength="200"
                    type="text"
                    @keydown.enter="searchEvent"
                    v-model="keyword"
                    v-on:click="clickKeyword()"
                    v-bind:placeholder="$t('message.Job title, company name or skill, etc')"
                    class="input-one"
                    autocomplete="off"
                    :aria-label="$t('message.Job title, company name or skill, etc')"
                  />
                  <b class="i-right" v-if="keyword" @click="clearEvent">
                    <i class="icon-close-1 gray" aria-hidden="true"></i>
                  </b>
                </div>
              </div>

              <div class="col-sm-6 pad-10" :class="{ show: showJobFunction }">
                <div class="input-group" @click="openJobFunc" role="combobox" :aria-label="$t('message.All Job Functions')">
                  <b class="i-left">
                    <i class="icon-box gray" aria-hidden="true"></i>
                  </b>
                  <div class="input-two allInput">
                    <span class="oneline-box" v-if="!jobFunctionDisplay">
                      <a href="javascript:;" style="color: inherit">{{ $t("message.All Job Functions") }}</a>
                    </span>
                    <span class="oneline-box" v-else>
                      {{ jobFunctionDisplay }}
                    </span>
                  </div>
                  <b class="i-right">
                    <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                  </b>
                </div>
                <div class="criteria-content can-scroll multi-layer criteria-job-func show-choice" :class="{ show: showJobFunction }">
                  <ul>
                    <li class="item-table" v-on:click="selectAllJobFn()" role="option" :aria-label="$t('message.All Job Functions')">
                      <div class="tdcell">
                        <a href="javascript:;" style="color: inherit">{{ $t("message.All Job Functions") }}</a>
                      </div>
                      <div class="tdcell width-25 text-right">
                        <span class="check-box" :class="selectedAllJobFunction ? 'checked' : ''"></span>
                      </div>
                    </li>
                    <li class="item-table" v-for="(jobFunction, index) in jobFunctions" v-on:click="selectJobFn(jobFunction)" role="option" :aria-label="$store.getters.getContent(jobFunction.title)">
                      <div class="tdcell">
                        <a href="javascript:;" style="color: inherit">{{ $store.getters.getContent(jobFunction.title) }}</a>
                      </div>
                      <div class="tdcell width-25 text-right">
                        <span class="check-box" :class="jobFunction.selected ? 'checked' : ''"></span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <VueSlideToggle :open="showExtra" :duration="500">
              <div class="extra-criteria row" :class="{ showExperience: showExtra }">
                <div class="col-sm-6 pad-10" :class="{ show: showLevel }">
                  <div class="input-group" @click="openLevel" role="combobox" :aria-label="$t('message.All Level of Positions')">
                    <b class="i-left">
                      <i class="icon-level gray" aria-hidden="true"></i>
                    </b>
                    <div class="input-two allInput">
                      <span class="oneline-box" v-if="!levelDisplay">
                        <a href="javascript:;" style="color: inherit">{{ $t("message.All Level of Positions") }}</a>
                      </span>
                      <span class="oneline-box" v-else>{{ levelDisplay }}</span>
                    </div>
                    <b class="i-right">
                      <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                    </b>
                  </div>
                  <div class="criteria-content multi-layer criteria-job-func show-choice experienceList" :class="{ show: showLevel }">
                    <ul>
                      <li class="item-table" v-on:click="selectAllLevelFn()" role="option" :aria-label="$t('message.All Level of Positions')">
                        <div class="tdcell">
                          <a href="javascript:;" style="color: inherit">{{ $t("message.All Level of Positions") }}</a>
                        </div>
                        <div class="tdcell width-25 text-right">
                          <span class="check-box" :class="selectedAllLevel ? 'checked' : ''"></span>
                        </div>
                      </li>
                      <li class="item-table" v-for="(jobLevel, index) in jobLevelList" v-on:click="selectLevelFn(jobLevel)" role="option" :aria-label="$store.getters.getContent(jobLevel.name)">
                        <div class="tdcell">
                          <a href="javascript:;" style="color: inherit">{{ $store.getters.getContent(jobLevel.name) }}</a>
                        </div>
                        <div class="tdcell width-25 text-right">
                          <span class="check-box" :class="jobLevel.selected ? 'checked' : ''"></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 pad-10" :class="{ show: showType }">
                  <div class="input-group" @click="openType" role="combobox" :aria-label="$t('message.All Job Types')">
                    <b class="i-left">
                      <i class="icon-clock gray" aria-hidden="true"></i>
                    </b>
                    <div class="input-two allInput">
                      <span class="oneline-box" v-if="!typeDisplay">
                        <a href="javascript:;" style="color: inherit">{{ $t("message.All Job Types") }}</a>
                      </span>
                      <span class="oneline-box" v-else>{{ typeDisplay }}</span>
                    </div>
                    <b class="i-right">
                      <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                    </b>
                  </div>
                  <div class="criteria-content multi-layer criteria-job-func show-choice experienceList" :class="{ show: showType }">
                    <ul>
                      <li class="item-table" v-on:click="selectAllTypeFn()" role="option" :aria-label="$t('message.All Job Types')">
                        <div class="tdcell">
                          <a href="javascript:;" style="color: inherit">{{ $t("message.All Job Types") }}</a>
                        </div>
                        <div class="tdcell width-25 text-right">
                          <span class="check-box" :class="selectedAllType ? 'checked' : ''"></span>
                        </div>
                      </li>
                      <li class="item-table" v-for="(jobType, index) in jobTypeList" v-on:click="selectTypeFn(jobType)" role="option" :aria-label="$store.getters.getContent(jobType.name)">
                        <div class="tdcell">
                          <a href="javascript:;" style="color: inherit">{{ $store.getters.getContent(jobType.name) }}</a>
                        </div>
                        <div class="tdcell width-25 text-right">
                          <span class="check-box" :class="jobType.selected ? 'checked' : ''"></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </VueSlideToggle>
          </div>

          <div class="col-sm-12 more-options moreOptions SemiBold" v-if="needOptions && $store.state.innerWidth <= 768">
            <span class="moreOptions" v-if="!showExtra">
              <span class="pointer" @click="moreEvent" role="button" :aria-label="$t('message.More Options')">
                {{ $t("message.More Options") }}
              </span>
            </span>
            <span class="moreOptions" v-if="showExtra">
              <span class="pointer" @click="moreEvent" role="button" :aria-label="$t('message.Fewer Options')">
                {{ $t("message.Fewer Options") }}
              </span>
            </span>
          </div>
          <div class="col-sm-4 col-lg-3 moreGroup" v-if="$store.state.innerWidth >= 770">
            <div class="row">
              <div class="col-xs-12 col-md-12 search-btn pad-10">
                <div class="btn btn-primary" v-on:click="searchEvent()" role="button" :aria-label="$t('message.Search')">
                  <a href="javascript:;" style="color: inherit">{{ $t("message.Search") }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 more-options moreOptions SemiBold" v-if="needOptions && $store.state.innerWidth > 768">
            <span class="moreOptions" v-if="!showExtra">
              <span class="pointer" @click="moreEvent" role="button" :aria-label="$t('message.More Options')">
                <a href="javascript:;" style="color: inherit">{{ $t("message.More Options") }}</a>
              </span>
            </span>
            <span class="moreOptions" v-if="showExtra">
              <span class="pointer" @click="moreEvent" role="button" :aria-label="$t('message.Fewer Options')">
                <a href="javascript:;" style="color: inherit">{{ $t("message.Fewer Options") }}</a>
              </span>
            </span>
          </div>

          <!-- instant-filter -->
          <div class="instant-filter pad-10">
            <label class="filter-label">
              {{ $t("message.Instant-filter") }}
            </label>
            <div class="filter-group">
              <div class="filter-btn">
                <button :class="{ 'filterActive': instantActive.filter == 'entryFilter' }" @click="instantFilter('entryFilter', 1, 'levelData')">
                  <a href="javascript:;" style="color: inherit">{{ $t("message.Entry level") }}</a>
                </button>
              </div>
              <div class="filter-btn">
                <button :class="{ 'filterActive': instantActive.filter == 'partTimeFilter' }" @click="instantFilter('partTimeFilter', 2, 'typeData')">
                  <a href="javascript:;" style="color: inherit">{{ $t("message.Part time") }}</a>
                </button>
              </div>
              <div class="filter-btn">
                <button :class="{ 'filterActive': instantActive.filter == 'csbFilter' }" @click="instantFilter('csbFilter', 1, 'jobTypeId')">
                  <a href="javascript:;" style="color: inherit">{{ $t("message.Government vacancies") }}</a>
                </button>
              </div>
              <!-- <div class="filter-btn">
                <button :class="{ 'filterActive': instantActive.filter == 'jobCreationFilter' }" @click="instantFilter('jobCreationFilter', 7, 'jobTypeId')">{{ $t("message.Job Creation Scheme") }}</button>
              </div> -->
              <div class="filter-btn" v-for="(job, index) in shortTermList" :key="index">
                <button :class="{ 'filterActive': instantActive.filter == `jobSourceFilter${index}` }" @click="instantFilter(`jobSourceFilter${index}`, job.id, 'jobSourceId')">
                  <a href="javascript:;" style="color: inherit">{{ $store.getters.getContent(job.name) }}</a>
                </button>
              </div>
            </div>
          </div>

          <div class="col-sm-4 col-lg-3 moreGroup" v-if="$store.state.innerWidth < 770">
            <div class="row">
              <div class="col-xs-12 col-md-12 search-btn pad-10">
                <div class="btn btn-primary" v-on:click="searchEvent()" role="button" :aria-label="$t('message.Search')">
                  <a href="javascript:;" style="color: inherit">{{ $t("message.Search") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mask"
      @click="closePopup"
      :class="{
        show: showJobFunction || showType || showLevel,
        maskPC: $store.state.innerWidth > 768,
      }"
    ></div>
  </div>
</template>
<script>
import { VueSlideToggle } from "vue-slide-toggle";
export default {
  data() {
    return {
      showJobFunction: false,
      keyword: "",
      jobFunctionIds: "",
      isMobile: false,
      showExtra: false,
      showLevel: false,
      showType: false,
      jobFunctions: [],
      jobLevelList: [],
      selectedAllJobFunction: false,
      selectedAllLevel: false,
      jobFunctionDisplay: "",
      levelDisplay: "",
      levelData: "",
      typeDisplay: "",
      typeData: "",
      jobTypeList: [],
      selectedAllType: false,
      instantActive: {},
      jobSourceId: "",
      jobTypeId: "",
      shortTermList: [],
    };
  },
  props: ["needOptions", "search", "childLogGaEvent", "filterActive", "jobSource", "jobType"],

  components: {
    VueSlideToggle,
  },
  methods: {
    clickKeyword: function () {
      this.childLogGaEvent("userClick", "filterJobOpportunity", "Keyword");
    },
    openJobFunc: function () {
      this.childLogGaEvent("userClick", "filterJobOpportunity", "Job Function");
      this.showLevel = false;
      this.showType = false;
      this.showJobFunction = !this.showJobFunction;
      if (this.comment.getType()) {
        this.isMobile = true;
      }
    },
    moreEvent: function () {
      this.childLogGaEvent("userClick", "moreOptions", "More Options");
      this.showExtra = !this.showExtra;
    },
    openLevel: function () {
      this.childLogGaEvent("userClick", "filterJobOpportunity", "openLevel");
      this.showJobFunction = false;
      this.showType = false;
      this.showLevel = !this.showLevel;
      if (this.comment.getType()) {
        this.isMobile = true;
      }
    },
    openType: function () {
      this.childLogGaEvent("userClick", "filterJobOpportunity", "showType");
      this.showJobFunction = false;
      this.showLevel = false;
      this.showType = !this.showType;
      if (this.comment.getType()) {
        this.isMobile = true;
      }
    },
    searchEvent: function () {
      var that = this;
      this.childLogGaEvent("search", "filterJobOpportunity", that.keyword);
      this.search({
        keyword: that.keyword,
        jobFunctionIds: that.jobFunctionIds,
        level: that.levelData,
        type: that.typeData,
        jobSourceId: that.jobSourceId,
        jobType: that.jobTypeId,
      });
    },
    getJobFunctionList: function () {
      let that = this;
      this.api.getJobFunctionList({}, function (data) {
        if (that.$route.query.keyword) {
          that.keyword = that.$route.query.keyword;
        }
        if (that.$route.query.jobFunctionIds) {
          //
          that.jobFunctionIds = that.$route.query.jobFunctionIds;
          that.jobFunctions = data.result.map(function (v, i) {
            v.selected = !!that.jobFunctionIds.split(",").find(job => job == v.id);
            return v;
          });
        } else if (that.$route.query.jobFunctionCode) {
          let jobIds = [];
          that.jobFunctions = data.result.map(function (v, i) {
            v.selected = !!that.$route.query.jobFunctionCode.split(",").find(job => job == v.jobFunctionCode);
            if (v.selected) {
              jobIds.push(v.id);
            }
            return v;
          });
          that.jobFunctionIds = jobIds.join(",");
        } else {
          that.jobFunctions = data.result.map(function (v, i) {
            v.selected = false;
            return v;
          });
        }
        // if(that.selectedAllJobFunction){
        //     that.jobFunctions.map(function(v, i) {
        //         v.selected = that.selectedAllJobFunction;
        //         return v
        //     });
        // }
      });
    },
    getJobLevelList: function () {
      let that = this;
      this.api.getJobLevelList({}, function (data) {
        if (that.$route.query.level) {
          that.jobLevelList = data.result.map(function (v, i) {
            v.selected = !!that.$route.query.level.split(",").find(job => job == v.code);
            return v;
          });
        } else {
          that.jobLevelList = data.result.map(function (v, i) {
            v.selected = false;
            return v;
          });
        }
      });
    },
    getJobTypeList: function () {
      let that = this;
      this.api.getJobTypeList({}, function (data) {
        if (that.$route.query.jobType) {
          that.jobTypeList = data.result.map(function (v, i) {
            v.selected = !!that.$route.query.jobType.split(",").find(job => job == v.code);
            return v;
          });
        } else {
          that.jobTypeList = data.result.map(function (v, i) {
            v.selected = false;
            return v;
          });
        }
      });
    },
    selectJobFn: function (job) {
      //
      this.childLogGaEvent("userSelect", "jobFunction", this.$store.getters.getContent(job.title));
      job.selected = !job.selected;
    },
    selectAllJobFn: function () {
      this.childLogGaEvent("userSelect", "jobFunction", "All Job Functions");
      let that = this;
      that.selectedAllJobFunction = !that.selectedAllJobFunction;
      that.jobFunctions.map(function (v, i) {
        v.selected = that.selectedAllJobFunction;
        return v;
      });
    },
    selectLevelFn: function (obj) {
      this.childLogGaEvent("userSelect", "Level", this.$store.getters.getContent(obj.name));
      obj.selected = !obj.selected;
    },
    selectAllLevelFn: function () {
      this.childLogGaEvent("userSelect", "Level", "All Level");
      let that = this;
      that.selectedAllLevel = !that.selectedAllLevel;
      that.jobLevelList.map(function (v, i) {
        v.selected = that.selectedAllLevel;
        return v;
      });
    },
    selectTypeFn: function (obj) {
      this.childLogGaEvent("userSelect", "Type", this.$store.getters.getContent(obj.name));
      obj.selected = !obj.selected;
    },
    selectAllTypeFn: function () {
      this.childLogGaEvent("userSelect", "Type", "All Type");
      let that = this;
      that.selectedAllType = !that.selectedAllType;
      that.jobTypeList.map(function (v, i) {
        v.selected = that.selectedAllType;
        return v;
      });
    },
    clearEvent: function () {
      this.keyword = "";
    },
    closePopup: function () {
      this.showJobFunction = false;
      this.showType = false;
      this.showLevel = false;
    },
    getShortTermList: function () {
      let that = this;
      this.api.getShortTermList({}, function (data) {
        if (data.errorCode == 0) {
          data.result.forEach(function (item, index, value) {
            item.name = [
              { langCode: "en_US", content: item.jobSourceName },
              { langCode: "zh_HK", content: item.jobSourceNameHk },
              { langCode: "zh_CN", content: item.jobSourceNameCn },
            ];
          });
          that.shortTermList = data.result;

          for (let i = 0; i < that.shortTermList.length; i++) {
            if (that.shortTermList[i].id == that.$route.query.jobSourceId) {
              that.instantActive.filter = `jobSourceFilter${i}`;
            }
          }
        }
      });
    },
    instantFilter: function (filter, id, type) {
      let that = this;
      new Promise((resolve, reject) => {
        if (this.instantActive.filter == "") {
          this.instantActive = {
            filter: filter,
            type: type,
            id: id,
          };
          this.checkInstantType(type, id, id);
        } else if (this.instantActive.filter == filter) {
          this.instantActive = {
            filter: "",
            type: "",
            id: "",
          };
          this.checkInstantType(type, id, "");
        } else {
          this.checkInstantType(this.instantActive.type, this.instantActive.id, "");

          this.instantActive = {
            filter: filter,
            type: type,
            id: id,
          };
          this.checkInstantType(type, id, id);
        }
        resolve();
      }).then(() => {
        this.searchEvent();
      });
    },
    checkInstantType: function (type, id, value) {
      if (type == "jobTypeId" || type == "jobSourceId") {
        this[type] = value;
      } else {
        let allSelect,
          dataList,
          that = this;
        type == "levelData" ? ((allSelect = this.selectedAllLevel), (dataList = this.jobLevelList)) : ((allSelect = this.selectedAllType), (dataList = this.jobTypeList));

        if (!allSelect) {
          if (value) {
            // 增加条件
            if (this[type] == "") {
              this[type] = value;
            } else {
              this[type] += "";
              this[type].indexOf(value) < 0 ? (this[type] += `,${value}`) : "";
            }
          } else {
            // 移除条件
            dataList.forEach((item, index, value) => {
              if (item.code == id) {
                if (!item.selected) {
                  that[type] += "";
                  let arr = that[type].split(",");
                  arr.splice(arr.indexOf(id), 1);
                  that[type] = arr.join(",");
                }
              }
            });
          }
        }
      }
    },
  },
  mounted() {
    this.getJobFunctionList();
    this.getJobLevelList();
    this.getJobTypeList();
    this.getShortTermList();
  },
  computed: {
    _language() {
      return this.$store.state.language;
    },
  },
  watch: {
    jobFunctions: {
      handler: function (val, oldval) {
        let that = this;

        //selected job Function
        let selectedJobFunctions = that.jobFunctions.filter(jobFunction => jobFunction.selected);

        this.selectedAllJobFunction = selectedJobFunctions.length == this.jobFunctions.length;
        if (that.selectedAllJobFunction) {
          this.jobFunctionDisplay = this.$i18n.t("message.All Job Functions");
          this.jobFunctionIds = "";
        } else {
          this.jobFunctionDisplay = selectedJobFunctions
            .map(function (v, i) {
              return that.$store.getters.getContent(v.title);
            })
            .join(","); //title , title
          this.jobFunctionIds = selectedJobFunctions
            .map(function (v, i) {
              return v.id;
            })
            .join(",");
        }
      },
      deep: true,
    },
    jobLevelList: {
      handler: function (val, oldval) {
        let that = this;
        let selectedLevel = that.jobLevelList.filter(level => level.selected);

        this.selectedAllLevel = selectedLevel.length == this.jobLevelList.length;
        if (that.selectedAllLevel) {
          this.levelDisplay = this.$i18n.t("message.All Level of Positions");
          this.levelData = "";
        } else {
          this.levelDisplay = selectedLevel
            .map(function (v, i) {
              return that.$store.getters.getContent(v.name);
            })
            .join(","); //title , title

          // this.levelData = selectedLevel.map(function (v, i) {
          //   return v.code;
          // }).join(",");

          let selectArr = [];
          selectArr = selectedLevel.map(function (v, i) {
            return v.code;
          });

          if (this.instantActive.filter == "entryFilter") {
            if (selectArr.indexOf(1) < 0) {
              selectArr.push("1");
            }
          }
          this.levelData = selectArr.join(",");
        }
      },
      deep: true,
    },
    jobTypeList: {
      handler: function (val, oldval) {
        let that = this;
        let selectedType = that.jobTypeList.filter(level => level.selected);

        this.selectedAllType = selectedType.length == this.jobTypeList.length;
        if (that.selectedAllType) {
          this.typeDisplay = this.$i18n.t("message.All Job Types");
          this.typeData = "";
        } else {
          this.typeDisplay = selectedType
            .map(function (v, i) {
              return that.$store.getters.getContent(v.name);
            })
            .join(","); //title , title

          // this.typeData = selectedType.map(function (v, i) {
          //   return v.code;
          // }).join(",");

          let selectArr = [];
          selectArr = selectedType.map(function (v, i) {
            return v.code;
          });

          if (this.instantActive.filter == "partTimeFilter") {
            if (selectArr.indexOf(2) < 0) {
              selectArr.push("2");
            }
          }
          this.typeData = selectArr.join(",");
        }
      },
      deep: true,
    },
    _language: {
      handler: function (val, oldVal) {
        let that = this;
        let selectedJobFunctions = that.jobFunctions.filter(jobFunction => jobFunction.selected);

        this.selectedAllJobFunction = selectedJobFunctions.length == this.jobFunctions.length;
        if (that.selectedAllJobFunction) {
          this.jobFunctionDisplay = this.$i18n.t("message.All Job Functions");
          this.jobFunctionIds = "";
        } else {
          this.jobFunctionDisplay = selectedJobFunctions
            .map(function (v, i) {
              return that.$store.getters.getContent(v.title);
            })
            .join(","); //title , title
          this.jobFunctionIds = selectedJobFunctions
            .map(function (v, i) {
              return v.id;
            })
            .join(",");
        }
        let selectedLevel = that.jobLevelList.filter(level => level.selected);

        this.selectedAllLevel = selectedLevel.length == this.jobLevelList.length;
        if (that.selectedAllLevel) {
          this.levelDisplay = this.$i18n.t("message.All Level of Positions");
          this.levelData = "";
        } else {
          this.levelDisplay = selectedLevel
            .map(function (v, i) {
              return that.$store.getters.getContent(v.name);
            })
            .join(","); //title , title
          this.levelData = selectedLevel
            .map(function (v, i) {
              return v.code;
            })
            .join(",");
        }

        let selectedType = that.jobTypeList.filter(level => level.selected);

        this.selectedAllType = selectedType.length == this.jobTypeList.length;
        if (this.selectedAllType) {
          this.typeDisplay = this.$i18n.t("message.All Job Types");
          this.typeData = "";
        } else {
          this.typeDisplay = selectedType
            .map(function (v, i) {
              return that.$store.getters.getContent(v.name);
            })
            .join(","); //title , title
          this.typeData = selectedType
            .map(function (v, i) {
              return v.code;
            })
            .join(",");
        }
      },
      deep: true,
    },
    filterActive: {
      handler: function (val, oldVal) {
        if (JSON.stringify(val) != "{}") {
          this.instantActive = val;
        } else {
          this.instantActive = {
            filter: "",
            type: "",
            id: "",
          };
        }
      },
      deep: true,
      // immediate: true,
    },
    jobSource: {
      handler: function (val, oldVal) {
        this.jobSourceId = val;
      },
    },
    jobType: {
      handler: function (val, oldVal) {
        this.jobTypeId = val;
      },
    },
  },
};
</script>
